import React, { useEffect } from "react";
import { setTitle } from "@store/title-store";

export function UserGuide() {
  useEffect(() => {
    setTitle([
      { title: "Главная", href: "/" },
      { title: "Руководство пользователя", href: "/user-guide" },
    ]);
  }, []);

  return (
    <main className="content-container">
      <div className="content-section"></div>
    </main>
  );
}
